<template>
  <div>
    <div class="row" v-if="mainShow == true">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-md-0">
        <div class="d-flex">
          <form
            class="sign-in-sign-up-form w-100 p-0"
            ref="form"
            data-url="/user/confirm"
            action="store">
            <div class="mt-3" v-if="isHidden == true">
              <div class="form-row">
<!--              already have an account  -->
              </div>
              <div class="row" style="align-items: center">
                <div class="col-4">
                  <div>
                    <img
                      :src="'/images/buyer_supplier.png'"
                      alt="buyer-supplier vector"
                      class="img-fluid"
                    />
                  </div>
                </div>
                <div class="col-8">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12" style="cursor: pointer">
                      <div class="mb-primary">
                        <div
                          class="
                            card card-with-shadow
                            dashboard-widgets dashboard-icon-widget
                            p-primary
                            border-0
                            title_class_registration
                          "
                          @click="toggleComponentOne(5)"
                        >
                          <div class="icon-wrapper text-center">
                            <app-icon name="sunset" />
                          </div>
                          <div class="widget-data mt-3 ml-0">
                            <p>{{ $t("supplier_registration_text") }}</p>
                            <h6 class="mt-3">
                              {{ $t("supplier_registration_heading") }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12" style="cursor: pointer">
                      <div class="mb-primary mb-3">
                        <div
                          class="
                            card card-with-shadow
                            dashboard-widgets dashboard-icon-widget
                            p-primary
                            border-0
                            title_class_registration
                          "
                          @click="toggleComponentOne(4)"
                        >
                          <div class="icon-wrapper text-center">
                            <app-icon name="sunrise" />
                          </div>
                          <div class="widget-data mt-3 ml-0">
                            <p>{{ $t("buyer_registration_text") }}</p>
                            <h6 class="mt-3">
                              {{ $t("buyer_registration_heading") }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12" style="cursor: pointer">
                      <div class="mb-primary mb-3">
                        <div
                          class="
                            card card-with-shadow
                            dashboard-widgets dashboard-icon-widget
                            p-primary
                            border-0
                            title_class_registration
                          "
                          @click="toggleComponentOne('Screening Portal')"
                        >
                          <div class="icon-wrapper text-center">
                            <app-icon name="sunrise" />
                          </div>
                          <div class="widget-data mt-3 ml-0">
                            <p>{{ $t("screening_portal_description") }}</p>
                            <h6 class="mt-3">
                              {{ $t("screening_portal") }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12" style="cursor: pointer">
                      <div class="mb-primary mb-3">
                        <div
                          class="
                            card card-with-shadow
                            dashboard-widgets dashboard-icon-widget
                            p-primary
                            border-0
                            title_class_registration
                          "
                          @click="toggleComponentOne('Training Portal')"
                        >
                          <div class="icon-wrapper text-center">
                            <app-icon name="sunrise" />
                          </div>
                          <div class="widget-data mt-3 ml-0">
                            <p>{{ $t("buyer_registration_text") }}</p>
                            <h6 class="mt-3">
                              {{ $t("training_portal") }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showComponentOne">
              <div class="form-row">
                <div class="form-group col-12 px-0">
                  <h6 class="text-center mb-0">
                    {{ $t("verify_your_email") }}
                  </h6>
                  <label class="text-center d-block">
                    {{ $t("ready_to_register") }}</label
                  >
                </div>
              </div>
              <div class="row" style="align-items: center">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <div>
                    <img
                      :src="'/images/Asset1.png'"
                      alt="email-image template"
                      class="img-fluid"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12" v-if="otp == false">
                  <div class="form-row">
                    <div class="form-group col-12 px-0">
                      <!-- <h6 class="text-center mb-0">{{ $t("hi_there") }}</h6> -->
                      <label
                        style="text-align: start !important; line-height: 21px"
                        class="d-block"
                        >{{ $t("email_sent_note") }}</label
                      >
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-12 px-0">
                      <label for="login_email">{{ $t("email") }}</label>
                      <app-input
                        type="email"
                        :placeholder="$t('enter_your_email')"
                        :required="true"
                        v-model="inputs.email"
                      />

                      <label
                        class="text-danger"
                        for=""
                        v-if="emailErrorShow == true"
                        >{{ this.message }}</label
                      >
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-12 text-center">
                      <app-load-more
                        :preloader="preloader"
                        :label="$t('sign_up')"
                        type="submit"
                        class-name="btn btn-primary text-center btn-block"
                        @submit="submit"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12" v-if="otp == true">
                  <div class="form-row">
                    <div class="form-group col-12 px-0">
                      <!-- <h6 class="text-center mb-0">{{ $t("hi_there") }}</h6> -->
                      <label
                        style="text-align: start !important; line-height: 21px"
                        class="d-block"
                        >{{ $t("otp_note") }}</label
                      >
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-12 px-0">
                      <label for="login_email">{{ $t("otp_code") }}</label>
                      <app-input
                        type="number"
                        :placeholder="$t('otp_number')"
                        :required="true"
                        v-model="inputs.number"
                      />

                      <label
                        class="text-danger"
                        for=""
                        v-if="emailErrorShow == true"
                        >{{ this.message }}</label
                      >
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-12 text-center">
                      <app-load-more
                        :preloader="preloader"
                        :label="$t('sign_up')"
                        type="submit"
                        class-name="btn btn-primary text-center btn-block"
                        @submit="submitotp"
                      />
                    </div>
                  </div>
                  <!-- <div class="form-row"> -->
                  <div
                    class="
                      form-row form-row
                      flex-column flex-md-row
                      justify-content-center
                    "
                  >
                    <a
                      href="#"
                      class="
                        bluish-text
                        d-flex
                        align-items-center
                        justify-content-center justify-content-lg-end
                      "
                      v-on:click="OtpAgain"
                    >
                      {{ $t("generate_opt_again") }}
                    </a>
                  </div>
                  <!-- <div class="form-group col-12 text-center">
                        <app-load-more
                          :label="$t('generate_opt_again')"
                          type="submit"
                          class-name="btn btn-primary text-center btn-block"
                          @submit="submitotp"
                        />
                      </div> -->
                  <!-- </div> -->
                </div>
              </div>
              <!-- <div class="form-row">
                        <div class="form-group col-12">
                            <app-load-more 
                            :preloader="preloader"
                            :label="$t('sign_up')"
                            :class="{'disabled': !userInfo}"
                            type="submit"
                            class-name="btn btn-primary btn-block text-center"
                            @submit="submit"/>
                        </div>
                    </div> -->
            </div>
            <!-- <div class="form-row branding_footer">
                <div class="col-12">
                  <p class="text-center mt-5">
                    {{ $t("copyright_text") + configData.company_name }}
                  </p>
                </div>
              </div> -->
          </form>
        </div>
      </div>
      <!-- </div>
    </div> -->
    </div>
  </div>
</template>

<script>
import ThemeMixin from "../../../../../core/mixins/global/ThemeMixin";
import { AuthMixin } from "../../Auth/Mixins/AuthMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";

import { DashboardPreloader } from "../../Demo/Dashboard/Mixins/DashboardPreloader";

import {
  COMPANY_CHECK,
  COMPANY_STORE,
  PACKAGES,
  USER_INVITATION,
  USER_OTP_INVITATION,
} from "../../../../Config/ApiUrl";

export default {
  name: "Registration",
  mixins: [AuthMixin, ThemeMixin, DashboardPreloader],

  props: {
    active: {},
    userInfo: {},
    siteKey: String,
    recaptchaEnable: {},
  },
  data() {
    return {
      otp: false,
      preloader: false,
      audienceChart: false,
      mainPreloader: true,
      userData: {},
      isHidden: true,
      showComponentOne: false,
      showComponentTwo: false,
      inputs: {},
      message: "",
      emailErrorShow: false,
      mainShow: true,
      emailMessage: "",
      loadershow: false,
      email: "",
    };
  },
  created() {
    this.mainPreloader = true;
    if (this.userInfo) {
      this.userData = JSON.parse(this.userInfo);
    }
  },
  methods: {
    OtpAgain() {
      this.otp = false;
    },
    submitotp() {
      this.otpinvite();
    },
    submit() {
      this.invite();
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      // location.replace("/admin/users/login");
    },
    toggleComponentOne(type) {
      this.active = 2;
      this.$emit("role", type);
      // $('.otp_value').val(this.randomnumber);
      // this.showComponentOne = !this.showComponentOne;
      this.inputs.roles = { 0: type };
      // this.isHidden = false;
    },
    invite() {
      this.preloader = true;
      this.loadershow = true;
      this.email = this.inputs.email;
      axiosPost(USER_INVITATION, this.inputs)
        .then((res) => {
          this.emailMessage = "Please check your email.";
          // this.mainShow = false;
          this.otp = true;
          this.$toastr.s("Please check your email.");
          this.inputs = {};
        })
        .catch((error) => {
          
          this.message = error.response.data.errors.email[0];
          this.emailErrorShow = true;
          this.loadershow = false;
          this.preloader = false;
        })
        .finally(() => {
          this.mainPreloader = false;
          this.countCreatedResponse++;
          this.preloader = false;
        });
    },
    otpinvite() {
      this.preloader = true;
      this.loadershow = true;
      this.inputs.email = this.email;
      
      axiosPost(USER_OTP_INVITATION, this.inputs)
        .then((res) => {
          location.replace("form/" + this.email);
          this.mainShow = false;
          // this.emailMessage = "Please check your email.";
          this.$toastr.s(res.data.message);
          this.inputs = {};
        })
        .catch((error) => {
          this.$toastr.e(error.response.data.message);
          // this.emailErrorShow = true;
          this.loadershow = false;
          this.preloader = false;
        })
        .finally(() => {
          this.mainPreloader = false;
          this.countCreatedResponse++;
          this.preloader = false;
        });
    },
  },
  mounted: function mounted() {
    $(".sign-in-sign-up-form .btn-primary").removeClass(
      "el-button el-button--default"
    );
    // $("body").addClass("bg_registration_graph");
    // $(".container-scroller").css("background-color", "transparent");
  },
};
</script>
<style scoped>
.title_class_registration {
  display: block !important;
  flex-direction: initial !important;
  text-align: -webkit-center !important;
}

.package_li {
  padding: 20px;
  text-align: center;
  background: grey;
  margin-bottom: 8px;
  margin-top: 8px;
  color: black;
}
.main-panel {
  display: flex;
  flex-direction: column;
  margin-left: 0px;
  width: calc(100% - 0px);
  min-height: calc(100vh- 0px);
  transition: width 0.25s ease-in-out, margin 0.25s ease-in-out;
}
.border_registration {
  background: #4466f2;
  border-radius: 0px;
  padding: 1.2rem !important;
}
.price_package {
  padding: 20px;
  text-align: center;
}

.subscrbe_button {
  background: transparent;
  border-radius: 0px;
  padding: 1.2rem !important;
}

/* demo */
.price {
  list-style-type: none;
  border: 1px solid #eee;
  margin: 0;
  padding: 0;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.price:hover {
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.2);
}

.price .header {
  background-color: #111;
  color: white;
  font-size: 25px;
}

.price li {
  border-bottom: 1px solid #eee;
  padding: 20px;
  text-align: center;
}

.price .grey {
  background-color: #eee;
  font-size: 20px;
}
/* .card_background_effect::after{
    content: "";
    display: block;
    width: 0px;
    height: 0px;
    background-color: skyblue;
    top: 0px;
    right: 0px;
    border-bottom: 20px solid darken(teal, 5%);
    border-left: 20px solid darken(teal, 5%);
    border-right: 20px solid yellow;
    border-top: 20px solid yellow;
    position: absolute;
    filter: drop-shadow(-5px 5px 3px rgba(0,0,0,0.5));
} */
 .card {
   transition: background-color 0.3s ease;
 }

.card:hover {
  background-color: #f0f0f0; /* Change this to your desired hover color */
}
</style>